import React from 'react';
import {
  Box,
  Heading,
  HStack,
  Icon,
  IconButton,
  Stack,
  Text,
  useColorModeValue,
  useToast,
} from '@chakra-ui/react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { MdArrowBack } from 'react-icons/md';
import { SidebarResponsive } from 'components/sidebar/Sidebar';
import InspectionForm from 'components/inspections/InspectionForm';
import Surface from 'components/ui/Surface';
import useCreateVehicleInspection from 'hooks/useCreateVehicleInspection';
import routes from 'routes';

export default function CreateInspectionView() {
  const navigate = useNavigate();
  const toast = useToast();
  const mutedText = useColorModeValue('secondaryGray.700', 'secondaryGray.500');
  const createMutation = useCreateVehicleInspection();

  const handleSubmit = (values) => {
    createMutation.mutate(values, {
      onSuccess: (response) => {
        toast({
          title: 'Inspection created',
          status: 'success',
          borderRadius: '18px',
        });
        navigate(`/admin/inspections/${response.data.uuid}`);
      },
    });
  };

  return (
    <Box pt={{}}>
      <HStack
        display={{ base: 'flex' }}
        justify="space-between"
        mb="18px"
        w="100%"
      >
        <IconButton
          as={RouterLink}
          to="/admin/inspections"
          aria-label="Back to inspection list"
          icon={<Icon as={MdArrowBack} boxSize="5" />}
          variant="outline"
          borderRadius="16px"
          size="md"
        />
        <SidebarResponsive routes={routes} />
      </HStack>
      <Stack spacing="10px" mb="28px">
        <Text
          textTransform="uppercase"
          letterSpacing="0.18em"
          fontSize="xs"
          color={mutedText}
          fontWeight="700"
        >
          New Inspection
        </Text>
        <Heading size="2xl">Create Inspection</Heading>
        <Text color={mutedText} fontSize="lg">
          Add a new vehicle inspection with the four required views and any
          optional supporting photos.
        </Text>
      </Stack>
      <Surface p={{ base: '22px', xl: '30px' }}>
        <InspectionForm
          isSubmitting={createMutation.isPending}
          errorMessage={
            createMutation.error?.response?.data?.error?.message ||
            createMutation.error?.message
          }
          onSubmit={handleSubmit}
        />
      </Surface>
    </Box>
  );
}
